@if (enabled) {
  <span
    class="sav-dev-flag"
    [class.sav-dev-flag--corner]="position() === 'corner'"
    [title]="tooltip()"
    [attr.aria-label]="tooltip()"
    role="img"
  ></span>
}
